module.exports = __webpack_public_path__ + "img/3.2ce1513f.jpg";